import { nativeAgentTurnMetadata, type NativeAgentHistoryEntry } from '@shared/nativeAgentTranscript';
import type { CanvasChatMessage } from './canvas-types';
import { hydrateConversation, type RawConversationEntry } from './conversation-hydrate';

export const nativeConversationMetadata = (entry: unknown) => nativeAgentTurnMetadata(entry as NativeAgentHistoryEntry);

export function pendingNativeConversationKey(messages: CanvasChatMessage[]): string {
  return messages.flatMap(message => {
    const metadata = nativeConversationMetadata(message);
    return message.role === 'assistant' && metadata?.status === 'running' ? [`${message.id}:${metadata.runId}`] : [];
  }).sort().join('|');
}

/** Update only the pending, matching server-owned rows. Preserve all newer UI. */
export function mergeNativeConversation(current: CanvasChatMessage[], history: RawConversationEntry[]): CanvasChatMessage[] {
  const saved = new Map(hydrateConversation(history).filter(message => nativeConversationMetadata(message)).map(message => [message.id, message]));
  let changed = false;
  const next = current.map(message => {
    const metadata = nativeConversationMetadata(message);
    const canonical = saved.get(message.id);
    const incoming = nativeConversationMetadata(canonical);
    // A late running read cannot erase local output or revive a finished turn.
    if (metadata?.status !== 'running' || !canonical || !incoming || incoming.runId !== metadata.runId || incoming.status === 'running') return message;
    changed = true;
    return { ...message, ...canonical, isStreaming: false, agentThinking: undefined, classifierReasoning: undefined };
  });
  return changed ? next : current;
}
